import YDropdownMenu from './src/main'

YDropdownMenu.install = function(Vue) {
  Vue.component(YDropdownMenu.name, YDropdownMenu)
}

export default YDropdownMenu
